import React from 'react';

const ErrorMessage = (props) => <><div className="form-group"><h2>{props.data.message}</h2></div><br/></>

export default ErrorMessage
